import { render, staticRenderFns } from "./DoorOtherDamages.vue?vue&type=template&id=6430a633&scoped=true"
import script from "./DoorOtherDamages.vue?vue&type=script&lang=ts"
export * from "./DoorOtherDamages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6430a633",
  null
  
)

export default component.exports